<!-- 密码验证 -->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body">
		<template slot="title">选择计费方式</template>
		<div class="formContainer" v-show="needVerify">
			<label><span class="required">*</span>登录密码</label>
			<input type="password" v-model.trim="verifyPassword" autocomplete="new-password" placeholder="请输入登录密码" />
		</div>
		<div class="tabHeader">
			<span v-for="tab in tabList" :class="{'tabAct':nowTab == tab.value}" @click="nowTab = tab.value">{{tab.text}}</span>
		</div>
		<div v-show="nowTab == 'SingleBilling'" class="tabBody custom-scrollbar">
			<div class="chargeMode" v-for="item in allChargeMode.SingleBilling">
				<div class="radio" :class="{'radioChecked':nowChargeModeId == item.pkid}" @click="nowChargeModeId = item.pkid"><span></span></div>
				<div class="chargeModeContent">
					<p class="chargeModeTitle">{{item.name}}</p>
					<p class="singlePrice">单价:{{item.deductionStandard}}元/度</p>
				</div>
			</div>
		</div>
		<div v-show="nowTab == 'StepBilling'" class="tabBody custom-scrollbar">
			<div class="chargeMode" v-for="item in allChargeMode.StepBilling">
				<div class="radio" :class="{'radioChecked':nowChargeModeId == item.pkid}" @click="nowChargeModeId = item.pkid"><span></span></div>
				<div class="chargeModeContent">
					<p class="chargeModeTitle">{{item.name}}</p>
					<div class="chargingDetails">
						<p class="flexBetween">0-{{item.stairNumOne}}度<span>{{item.priceOne}}元/度</span></p>
						<p class="flexBetween">{{item.stairNumOne}}-{{item.stairNumTwo}}度<span>{{item.priceTwo}}元/度</span></p>
						<p class="flexBetween">{{item.stairNumTwo}}度以上<span>{{item.priceThree}}元/度</span></p>
					</div>
				</div>
			</div>
		</div>
		<div v-show="nowTab == 'PeakAndValleyBilling'" class="tabBody custom-scrollbar">
			<div class="chargeMode" v-for="item in allChargeMode.PeakAndValleyBilling">
				<div class="radio" :class="{'radioChecked':nowChargeModeId == item.pkid}" @click="nowChargeModeId = item.pkid"><span></span></div>
				<div class="chargeModeContent">
					<p class="chargeModeTitle">{{item.name}}</p>
					<div class="chargingDetails">
						<p v-for="data in item.deductionStandard" class="flexBetween">{{data.sname}}<span>{{data.ratevalue}}元/度</span></p>
					</div>
				</div>
			</div>
		</div>
	</dialogBody>
</template>

<script>
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	import meterManagerStore from '../meterManagerStore.js'
	export default {
		components: {
			dialogBody
		},
		props: {
			
		},
		data() {
			return {
				title: '',
				verifyPassword: '',
				needVerify: true,
				callback: undefined,
				nowTab: 'SingleBilling',
				nowChargeModeId: '',
				tabList: [{text:'单价计费',value:'SingleBilling'},{text:'阶梯计费',value:'StepBilling'},{text:'费率计费',value:'PeakAndValleyBilling'}]
			}
		},
		computed: {
			allChargeMode() {
				return meterManagerStore.state.allChargeMode
			},
		},
		watch: {},
		mounted() {},
		methods: {
			confirm() {
				if(this.needVerify && (this.verifyPassword == '' || this.verifyPassword == undefined)){
					this.$dialogMethod.showMessage('登录密码为必填项')
					return
				}else if(this.nowChargeModeId == ''){
					this.$dialogMethod.showMessage('请选择计费方式')
					return
				}
				if(this.callback != undefined){
					this.callback({billingMode:this.nowTab,password:hex_md5(this.verifyPassword),pkid:this.nowChargeModeId})
				}
				this.close()
			},
			cancel() {
				this.close()
			},
			close() {
				this.verifyPassword = ''
				this.$refs.body.hide()
			},
			open(item, callBack) {
				if(!isempty(item)){
					this.nowTab = item.billingMode
					this.nowChargeModeId = item.billingModePkid
				}else{
					this.needVerify = false
				}
				this.callback = callBack
				this.$refs.body.open()
			},
		}
	}
</script>
<style scoped>
	.formContainer{
		padding-bottom: 10px;
		display: flex;
		align-items: center;
		border-bottom: solid 6px #E4E4E4;
	}
	
	.formContainer>label{
		min-width: 72px;
		text-align: right;
		display: inline-block;
		margin-right: 12px;
		line-height: 32px;
	}
	
	.formContainer>label>span{
		display: inline-block;
		width: 8px;
	}
	
	.formContainer>input{
		flex-grow: 1;
	}
	
	.required{
		color: red;
	}
	
	.tabHeader{
		border-bottom: solid 1px #E4E4E4;
	}
	
	.tabHeader>span{
		display: inline-block;
		margin-right: 30px;
		line-height: 30px;
		position: relative;
		top: 1px;
		cursor: pointer;
	}
	
	.tabAct{
		color: #409EFF;
		border-bottom: solid 1px #409EFF;
	}
	
	.tabBody{
		height: 312px;
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
	}
	
	.chargeMode{
		width: calc(50% - 10px);
		display: flex;
		margin: 20px 20px 0 0;
		width: calc((100% - 30px) / 2);
	}
	
	.chargeMode:nth-child(2n){
		margin-right: 0;
	}
	
	.chargeModeContent{
		border: solid 1px #E4E4E4;
		flex-grow: 1;
		border-radius: 4px;
	}
	
	.chargeModeTitle{
		text-align: center;
		background-color: #F2F2F2;
		line-height: 32px;
		border-bottom: solid 1px #E4E4E4;
	}
	
	.chargingDetails{
		padding: 0 10px;
	}
	
	.chargingDetails>p{
		line-height: 32px;
		text-align: left;
		color: #919191;
		border-bottom: solid 1px #E4E4E4;
	}
	
	.chargingDetails>p:last-child{
		border-bottom: none;
	}
	
	.chargingDetails>p>span{
		color: #919191;
	}
	
	
	
	.singlePrice{
		text-align: center;
		line-height: 45px;
	}
	
	.radio{
		display: inline-block;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		border: solid 1px #E4E4E4;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 10px;
		cursor: pointer;
	}
	
	.radio:hover{
		border-color: #409EFF;
	}
	
	.radio>span{
		width: 4px;
		height: 4px;
		border-radius: 50%;
		background-color: #FFFFFF;
	}
	
	.radioChecked{
		background-color: #409EFF;
	}
</style>